// extracted by mini-css-extract-plugin
export default {"container":"dashboard_container__kCFrd","leftPanel":"dashboard_leftPanel__xVDz0","content":"dashboard_content__fP3We"};